import classNames from 'classnames';
import Logo from 'components/common/Logo';
import { PropsWithChildren } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface AuthSimpleLayoutProps {
  logo?: boolean;
  className?: string;
}

const AuthSimpleLayout = ({
  logo = true,
  className = 'col-xl-5 col-xxl-3',
  children
}: PropsWithChildren<AuthSimpleLayoutProps>) => {
  return (
    <div className="container">
      <Row className="flex-center min-vh-100 py-5">
        <Col sm={10} md={8} lg={5} className={classNames(className)}>
          {logo && (
            <Link
              to="/"
              className="d-flex flex-center text-decoration-none mb-4"
            >
              <Logo
                text={false}
                width={200}
                className="fw-bolder fs-5 d-inline-block"
              />
            </Link>
          )}
          {children}
          <Row className="flex-between-center mb-7">
            <Col xs="auto" className="fs-9 fw-semibold">
              <Link to="/privacy-policy">Privacy policy</Link>
              {/* &nbsp;&nbsp;&nbsp;
              <Link to="/contact-us">Term & Condition</Link> */}
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default AuthSimpleLayout;
